import { useAuthContext } from '@repo/user-session';
import { ReactNode, Suspense, useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { refundHistoryQuery } from '@/__generated__/refundHistoryQuery.graphql';
import { RefundItemContextProvider } from '@/components/my/refund-history/providers/RefundItemContext';
import { refundHistory } from '@/graphql/query/tax-refund/refund-history';

interface RefundItemFetchGuardProps {
  children: ReactNode;
}

export const RefundItemFetchGuard = ({ children }: RefundItemFetchGuardProps) => {
  const { auth } = useAuthContext();
  const [queryRef, loadQuery] = useQueryLoader<refundHistoryQuery>(refundHistory);

  useEffect(() => {
    if (auth.apiToken) {
      loadQuery({});
    }
  }, [loadQuery, auth.apiToken]);

  if (queryRef) {
    return (
      <Suspense fallback={<></>}>
        <RefundItemContextProvider queryRef={queryRef}>{children}</RefundItemContextProvider>
      </Suspense>
    );
  }

  return <></>;
};
